module.exports = __webpack_public_path__ + "media/images/business/i-estimate-9321fa426e5452517033f436fccbab40.svg";